import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Navbar from "../../components/Navbar";
import ManageRoutes from "./ManageRoutes";
import Profile from "./Profile";
import RouteAllocations from "./RouteAllocations"; // Add this import
import QrScanner from "./QrScanner";
import NoticeTicker from "../../components/NoticeTicker";

const Home = () => {
  const router = useLocation();
  const navigate = useNavigate();
  const [load, setLoad] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("My Profile");

  useEffect(() => {
    const activeToken = localStorage.getItem("token");
    if (!router.state && !activeToken) {
      navigate("/");
    } else {
      setLoad(true);
    }

    const handleOpenProfile = () => setSelectedMenu("My Profile");
    window.addEventListener("openProfile", handleOpenProfile);
    return () => window.removeEventListener("openProfile", handleOpenProfile);
  }, [navigate, router.state]);

  return (
    <>
      {load && (
        <div className="min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100 transition-colors duration-250">
          <Navbar />
          <div className="max-w-7xl mx-auto p-4 md:p-6 lg:p-8 space-y-6">
            <div className="flex flex-wrap gap-2 justify-center p-1.5 bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xs">
              {["My Profile", "Manage Routes", "View Allocations", "QrScanner"].map((menu) => (
                <button
                  key={menu}
                  onClick={() => setSelectedMenu(menu)}
                  className={`px-4 py-2 rounded-xl text-xs font-bold transition-all cursor-pointer whitespace-nowrap ${
                    selectedMenu === menu
                      ? "bg-indigo-600 text-white shadow-xs"
                      : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-slate-50 dark:hover:bg-slate-800/60"
                  }`}
                >
                  {menu}
                </button>
              ))}
            </div>

            <div className="w-full">
              {selectedMenu === "My Profile" && <Profile />}
              {selectedMenu === "Manage Routes" && <ManageRoutes />}
              {selectedMenu === "View Allocations" && <RouteAllocations />}
              {selectedMenu === "QrScanner" && <QrScanner />}
            </div>
          </div>
        </div>
      )}
      <Toaster position="bottom-center" />
    </>
  );
};

export default Home;